/**
 * Formatters BR — moeda, data, CNPJ, etc.
 */

export const fmtMoeda = (n, opts = {}) => {
  if (n === null || n === undefined) return '—';
  const num = Number(n);
  if (isNaN(num)) return '—';
  if (num === 0 && !opts.zeroComoTraco === false) return '—';
  const negativo = num < 0;
  const abs = Math.abs(num).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return negativo ? `(${abs})` : abs;
};

export const fmtMoedaCompacta = (n) => {
  if (!n) return '—';
  const abs = Math.abs(n);
  if (abs >= 1e6) return (n / 1e6).toFixed(1).replace('.', ',') + 'M';
  if (abs >= 1e3) return (n / 1e3).toFixed(0) + 'k';
  return Math.round(n).toString();
};

export const fmtCnpj = (s) => {
  const c = (s || '').replace(/\D/g, '').padStart(14, '0');
  return `${c.slice(0,2)}.${c.slice(2,5)}.${c.slice(5,8)}/${c.slice(8,12)}-${c.slice(12,14)}`;
};

export const fmtCpf = (s) => {
  const c = (s || '').replace(/\D/g, '').padStart(11, '0');
  return `${c.slice(0,3)}.${c.slice(3,6)}.${c.slice(6,9)}-${c.slice(9,11)}`;
};

export const fmtData = (iso) => {
  if (!iso) return '—';
  // Data sem hora ("2026-07-13"): formata pelos digitos. Passar por new Date()
  // interpreta como meia-noite UTC e, em Recife (UTC-3), imprime o dia anterior.
  const so = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})(?:T00:00:00(?:\.000)?Z?)?$/);
  if (so) return `${so[3]}/${so[2]}/${so[1]}`;
  const d = new Date(iso);
  return isNaN(d) ? '—' : d.toLocaleDateString('pt-BR', { timeZone: 'America/Recife' });
};

export const fmtDataHora = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleString('pt-BR');
};

export const competenciaLabel = (comp) => {
  if (!comp) return '';
  const [a, m] = comp.split('-').map(Number);
  const meses = ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  return `${meses[m]}/${a}`;
};

export const mesAtual = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export const anosOpcoes = (n = 5) => {
  const atual = new Date().getFullYear();
  return Array.from({ length: n }, (_, i) => atual - i);
};

export const mesOpcoes = () => [
  { value: 1, label: 'Janeiro' }, { value: 2, label: 'Fevereiro' }, { value: 3, label: 'Março' },
  { value: 4, label: 'Abril' }, { value: 5, label: 'Maio' }, { value: 6, label: 'Junho' },
  { value: 7, label: 'Julho' }, { value: 8, label: 'Agosto' }, { value: 9, label: 'Setembro' },
  { value: 10, label: 'Outubro' }, { value: 11, label: 'Novembro' }, { value: 12, label: 'Dezembro' },
];
